export default "__VITE_ASSET__DJ5pRvyn__"